module.exports = "<select-all-checkbox checkboxes=\"params.data\" />"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/ng-table/selectAllHeader.html
 ** module id = 872
 ** module chunks = 0
 **/